import { DownloadTypes } from '../components/Generic/FileDownload/FileDownload';
import { MimeType, mimeTypesToDownload } from './mimeTypesToDownload';

const base64Formatter = (value: string) => {
  const base64Index = value.split('base64,');
  return base64Index[1];
};

const convertBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };

    fileReader.onerror = error => {
      reject(error);
    };
  });

const downloadFile = (fileName: string, base64Data: string, fileType: DownloadTypes = DownloadTypes.PDF) => {
  const linkSource =
    fileType === DownloadTypes.PDF
      ? `data:application/pdf;base64,${base64Data}`
      : `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;

  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const downloadTransactionDetailsFile = (fileName: string, base64Data: string, fileType: MimeType) => {
  const linkSource = `data:${mimeTypesToDownload[fileType]};base64,${base64Data}`;

  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export { base64Formatter, convertBase64, downloadFile, downloadTransactionDetailsFile };
